import React from 'react';
import parse from 'html-react-parser';

type TReportTypeHeaderProps = {
    readonly title: string;
    readonly subtitle?: string;
    readonly children?: React.ReactNode;
};

const ReportTypeHeader: React.FC<TReportTypeHeaderProps> = ({ title, subtitle = '', children }) => {
    return (
        <div className='mb-6'>
            <h1 id='REPORT_TYPE' className='report-type-header letter-spacing-normal mb-0 pb-0 text-left'>
                {parse(title)}
            </h1>
            {subtitle && (
                <span id='REPORT_TYPE_SUBTITLE' className='report-type-subtitle font-bold uppercase'>
                    {parse(subtitle)}
                </span>
            )}
            {children}
        </div>
    );
};

export type { TReportTypeHeaderProps };
export default ReportTypeHeader;
